import { registerStoreConfig, StoreConfig } from "@develos/next-library";
import appReducer from "./reducers";
import { metricLocalizationsApi } from "./metricLocalization/api";
import { portalSettingsApi } from "./portalSettings/api";
import { RMApiRequestEnum } from "@/constants";

export const storeConfig: StoreConfig = {
  reducers: appReducer,
  middlewares: [ metricLocalizationsApi.middleware,
    portalSettingsApi.middleware
   ],
  preloadedCoreState: {
    loading: {
      watchedKeys : [RMApiRequestEnum.getMetricLocalizations, RMApiRequestEnum.getUserSettings],
      [RMApiRequestEnum.getMetricLocalizations]: true,
      [RMApiRequestEnum.getUserSettings]: true,
    }
  }
};

registerStoreConfig(storeConfig);